var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasmineidle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.9 421.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b1b2;\n        stroke: #b2b1b2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #545554;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #535453;\n      }\n\n      .cls-3 {\n        fill: #545453;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #555;\n        stroke: #555;\n      }\n\n      .cls-6 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-7 {\n        fill: #717272;\n        stroke: #717272;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Mirror",
    "data-name": "Color Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.24,260.31l-5.49-29.42-8.86-4.48,4.37-17.05-5.23-18.77,8.93-6.78,4.93-9.64-14.46,7.06-17.49-4.48-4.71-7.17,2.47-18.95,9.19-16.24-2.24-12.46-11.77-12.22-7.4-7.43,7.17-17.44-1.12-8.88-4.6-7.62.34-24.38-15.47-11.15-11.44-4.6s-10.76-17.15-14.35-18.05c-3.59-.9-24.66-7.29-31.5-7.4-6.84-.11-34.87,6.39-39.35,8.41s-22.65,21.19-22.65,21.19l-17.44,33.8-3.07.17,1.91,7.06s-6.17,5.27-5.04,8.52c1.12,3.25,7.6,15.51,6.21,22.98l-18.59,16.32.49,13.93,5.07,12.39,4.31,11.8-1.29,11.91-4.35,7.33-19.14,2.59-11.85-8.62,6.36,13.47,6.57,3.45-3.56,19.91,4.42,16.32-9.47,6.51-4.33,32.28,14.1,62.71,20.49,61.89,171.83,3.93,12.89-33.52,5.04-17.6,3.3-2.58-3.18-3.83,3.18-6.8,5.67-1.25,4.15-13.68-5.25-3.83,3.39-7.06,3.77,1.14,1.25-9.35-3.15-2.42,6.05-31.9v-.02ZM112.46,107.88s-6.76,2.62-17.17,1.07c-12.87-1.91-12.93-12.03-12.93-12.03,0,0,11.09-1.19,13.77-1.19s17.82,6.85,17.82,6.85l-1.48,5.29h-.01ZM157.42,108.38c-10.34,2.02-18.28-.37-18.28-.37l-1.94-5.42s17.66-6.85,20.34-6.85,12.85,1.25,12.85,1.25c0,0-2.65,9.36-12.98,11.39h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.87,285s3.69-6.18,3.14-11.28-3.04-27.33-5.64-29.28-6.61-5.05-6.51-6.81c0,0,4.5.73,6.1.74s12.02,5.2,12.02,5.2l4.2,36.22-13.32,5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,234.48s3.62-3.5,1.22-6.38c-2.39-2.88-22.98,1.54-22.98,1.54,0,0-12.54,2.16-14.01,4.85s-1.99,2.69-1.99,2.69c0,0,.24-4.69,5.17-9.4,0,0,19.04-6.24,19.15-10.29s-7.08-12.69-7.08-12.69l10.25-10.29,21.78,22.76-3.9,13.39-7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.5,275.7c5.05-1.48-.2-4.79-1.63-4.79,0,0-3.73,4.67-6.75,4.59s0,11.07,0,11.07c0,0,4.59-9.76,8.37-10.87h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.39,285s-3.69-6.18-3.14-11.28,3.04-27.33,5.64-29.28,6.61-5.05,6.51-6.81c0,0-4.5.73-6.1.74s-12.02,5.2-12.02,5.2l-4.2,36.22,13.32,5.2h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.26,234.48s-3.62-3.5-1.22-6.38,22.98,1.54,22.98,1.54c0,0,12.54,2.16,14.01,4.85s1.99,2.69,1.99,2.69c0,0-.24-4.69-5.17-9.4,0,0-19.04-6.24-19.15-10.29s7.08-12.69,7.08-12.69l-10.25-10.29-21.78,22.76,3.9,13.39,7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.76,275.7c-5.05-1.48.2-4.79,1.63-4.79,0,0,3.73,4.67,6.75,4.59,3.02-.08,0,11.07,0,11.07,0,0-4.59-9.76-8.37-10.87h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.78,225.67l5.44-17.54-4.45-16.72,5.96-6.27,8.37-11.7-14.67,6.43-16.88-2.14-6.68-15.49,11.37-27.86s-2.25-17.44-6.83-21.19-12.45-9.84-12.45-9.84c0,0,2.97-12.64,6.1-17.09s-4.45-15-4.45-15l.7-9.06-3.96-20.09-21.4-11.43-18.09-22.22s-28.37-5.97-38.04-4.83c-9.67,1.14-41.47,6.26-49.83,19.52-8.36,13.27-21.99,44.14-21.99,44.14l-4.2-2.74,1.52,9.4-5.48,5.51,8.32,20.64-3.6,7.29s-17.96,13.97-17.99,19.76,15.3,28.54,11.24,40.83c0,0,5.35-2.17,4.76-13.92s-1.39-18.74.05-18.89,11.31,11.86,13.26,16.06c2.5,5.39,3.65,16.35,3.65,16.35,1.58-.24,5.2-2.48,5.2-12.46s6.25,5.04,6.55,8.01,3.6,19.69-6.68,30.59c-8.38,8.89-11.47,12.06-13.24,16.92-.69,1.9-2.96,2.68-4.68,1.61-2.64-1.66-6.04-4.18-7.67-7.04-3.12-5.46-1.19-15.47-1.19-15.47l-14.54,1.63-8.81,1.64-3.87,15.09,3.87,14.65.17,3.63-8.35,6.19-6.8,31.41,2.76,14.27s.46-13.11,4.63-21.88c4.16-8.77,7.14-11.45,12.79-11.45s11.87.72,13.98,7.27c2.11,6.54,1.6,32.49,3.39,43.05s17.46,47.9,16.78,51.79l7.18-4.84s4.69-5.82,16.56-5.76,26.75-2.77,26.75-2.77l-17.4-6.97-27.86,3.9-8.34-29.03-.68-20.31,11.96-2.99,1.77-36.1s13.52-5.28,15.01-6.06c0,0-14.09-5.08-14.9-8.78s2.89-20.8,2.89-20.8c0,0,2.66,12.04,8.03,12.95,5.37.91,8.14,1.37,8.14,1.37,0,0-6.59-5.31-6.35-7.51s16.75-15.13,16.75-15.13l4.27-12.02s19.37,20.1,25.51,19.87c6.15-.23,14.81-3.7,18.51-8.55,0,0-1.5,8.96.81,10.6s10.28,5.8,10.28,5.8l-1.95-13.24,4.36-.92s13.71,9.93,13.71,12.61-6.56,8.08-6.56,8.08c0,0,3.49,1.71,8.45-.97,4.96-2.68,9.25-9.47,9.25-9.47l2.25,15.65-7.25,9.88-6.71-.63,8.14,6.2,10.34,2.7,2.42,33.75,6.34,3.99,1.62-22.21,6.03-8.77s7.3-.82,12.33-4.12c5.04-3.3,8.17-6.07,10.15-4.1,1.98,1.96,7.75,8.22,5.52,21.9-2.23,13.68-6.78,28.35-6.78,28.35l8.67-3.82,7.29,4.24,4.75-31.56-4.75-29.99-10.58-5.78h.03ZM180.66,96.34l-10.9,13.11-1.56,11.94,7.32,11.51-10.97,20.84-21.06,20.63-15.09,9.66-9.34-2.17-29.61-22.55-7.16-12.89-6.66-14.68s6.74-11.78,6.9-15.36c.15-3.58-2.33-9.75-4.71-12.55-2.39-2.8-7.11-13.19-7.11-13.19l19.22-.96,11.34-6.72,11.83-22.15,19.11-9.75,13.13,2.08,9.99,6.81,10.81.26,10.66,7.62,5.44,8.32-1.57,20.19h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "227.48 305.08 237.87 309.07 239.7 303.74 236.93 302.25 227.48 305.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "226.43 329.23 231.84 333.6 232.36 329.58 226.43 329.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.39,359.43s8.52,11.82,15.22,12.85,116.12-22.71,131.6-31.48c0,0,21.68-2.43,34.84-5.35s12.24-4.05,12.24-4.05c0,0,1.3-7.27,2.18-7.27s9.46,2.63,11.13.5,1.04-6.75,1.04-6.75l-10.85-3.6s10.35,2.69,11.98,1.44,2.38-4.39,2.38-4.39l4.52,1.88-.96,6.15-3.18,8.15-5.25.65-3.35,7.28,2.44,3.23-2.44,3.14s-17.87,51.05-21.88,56.82-171.37-8.78-171.37-8.78l-10.28-30.44v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.32,293.01c.52,3.18-20,9.25-20,9.25l4.9,2.82,16.76-1.36,4.33-1.46-1.79-7.01-4.19-2.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.74,97.44s5.3,11.9,4.23,19.39-1.06,28.43,6.92,41.55l-12.6-16.68-5.67-9.96,6.9-15.36-11.82-25.74,39.98-45.8,55.06,5.5,21.29,25.08-9.76,53.1s-11.71,25.25-14.37,27.74-32.24,27.55-34.51,27.78-4.53-1.05-4.53-1.05c0,0,9.65-7.96,10.91-17.34,3.76-1.9,8.69-8.04,6.1-9.65l.7-.19s9-11.97,9.41-15.55,3.68-22.76,4.5-24.3,14.63-14.77,14.07-18.15c0,0-4.91-2-4.91-5.12s-.52-6.77-.52-6.77l2.93-1.52s1.28-14.58-1.59-17.55-14.84-2.95-20.62.07c-5.78,3.02-30.16,23.87-32.4,24.39-1.08.25-.39,6.65-2.43,7.89-2.18,1.33-7.16-2.52-10.58-2.85-6.64-.65-16.68,1.1-16.68,1.1h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.83,96.34s-2.02,1.14-2.12,4.03,2.02,30.21,1.06,33.1-2.57,4.8-2.57,4.8l9.69-2.78-2.58-32.54,11.24-5.15s-2.41-.96-.97-3.62,1.7-4.91,1.7-4.91l-15.46,7.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.91,276.52s-1.59,3.64,0,10.05,2.66,11.43,2.66,11.43l-10.45.27s1.5-11.64,2.66-14.44,5.12-7.32,5.12-7.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.45,280.56l7.82,31.73,98.28,5.61,21.75-12.85-1.65-25.25s-38.79,22.13-61.52,20.09-64.68-19.33-64.68-19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.13,306.95c-6.16,3.71-26.16,13.9-45.59,6.35s-16.05-18.9-15.47-33.5c0,0-5.47-1.54-9.52,2.02s7.07,46.85,7.07,46.85l27.31-3.86,20.03,9.52,15.35-2.26.83-25.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.59,306.95c6.16,3.71,26.16,13.9,45.59,6.35s16.05-18.9,15.47-33.5c0,0,5.47-1.54,9.52,2.02s-2.53,27.25-2.53,27.25l-26.89,14.92-23.89,3.95-16.49,2.7-.78-23.69h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "126.13 263.05 121.93 270.91 125.76 273.77 130.26 269.62 126.13 263.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.1,268.24s2.83,1.27,3.28,1.23l-.74-5.34-2.54,4.11Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.76,22.01s8-8.77,15.06-11.14c9.53-3.2,16.09-4.88,23.31,0,0,0-9.84,7.95-7.85,10.66s3.88,1,10.59,1.52c5.51.43,12.7,5.88,12.7,5.88,0,0-10.9-1.08-14.07,2.53,0,0,6.58,2.35,6.4,6.14s-10.25,2.73-19.04,10.31-15.01,17.62-23.46,19.38c0,0,12.51-18.3,7.63-24.62s-15.9,1.28-15.9,1.28c0,0,9.25-12.36,17.65-16.81,12.69-6.73-6.66-9.07-13.01-5.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.05,70.63c-.81-4.43,9.93-4.42,6.44-16s-14.43-15.86-16.49-13.16,0,9.36,0,9.36l5.07,6.66s-.59,3.53-4.42,2.72-5.69-1.13-5.69-1.13c0,0,8.19,13.59,6.46,31.57,0,0,10.69-8.79,8.63-20.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.76,127.02s10.98-18.58,10.98-21.76-2.13-8.92-2.13-8.92c0,0-4.37,13.76-4.96,18.01s-6.48,10.05-6.48,10.05l2.59,2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.99,127.02s-11.28-15.84-11.28-19.02,2.43-11.66,2.43-11.66c0,0,4.37,13.76,4.96,18.01s6.48,10.05,6.48,10.05c0,0-2.59,2.62-2.59,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.86,145.16s-16.27,9.08-14.92,22.03,20.33,26.44,17.98,44.46c-.58,4.45,4.21,4.45,7.42,1.74s18.54-17.01,15.23-25.32-13.56-15.08-12.21-26.67c0,0-1.13,12.37-7.91,7.54s-8.06-13.14-5.58-23.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.43,125.15c7.53,6.6,5.9,1.88,7.53-9.39,0,0,1.56,8.95,5.56,15.99,4,7.04,2.24,14.42-1.35,14.54s-5.57.64-6.27-4.68-.42-9.08-5.47-16.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.69,125.15c-7.53,6.6-5.9,1.88-7.53-9.39,0,0-1.56,8.95-5.56,15.99-4,7.04-2.24,14.42,1.35,14.54s5.57.64,6.27-4.68.42-9.08,5.47-16.47h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror_copy",
    "data-name": "Lines Mirror copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.57,95.37l-4.04,2.07s-10.37-1.45-13.69-1.04-14.72,5.18-17.52,6.95c0,0,1.59-4.46,3.83-6.09,1.28-.93,10.89-5.01,10.89-5.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.79,102.95s-7.79,5.28-11.85,5.61-14.37-.52-14.37-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.16,93.3c1.01-.78,17.06-7.73,19.09-7.73s11.98-1.18,15.18-.56c0,0-12.46.55-16.39,2.07s-18.8,9.51-19.81,9.26l1.93-3.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.03,138.83s-1.21-.74-2.42-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.45,134.38s-7.72,17.5-11.02,21.24-29.43,27.3-32.99,27.96-2.84.69-4.31.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.97,96.34s2.34,5,2.08,8.48-2.55,11.04-5.89,15.22-6.5,8.48-6.5,8.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.32,165.18s-1.91,19.09-1.65,24.82.64,11.64.67,18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.95,72.09s5.79,4.88,4.49,11.38-8.06,14.04-6.24,19.89,30.7,14.14,15.07,41.97c-15.47,27.55.52,34.31,11.44,34.05s21.05-11.36,21.05-11.36c0,0-5.88,25.74-26.81,23.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.78,191.41s5.46,14.7,3.54,21.78-5.32,25.33-27.11,26.83c0,0,7.62-10.01,4.35-19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.55,220.45s-1.71,13.25-12.18,18.59-27.56,4.27-35.89-3.63c0,0,12.61-1.28,14.96-8.97s.64-20.72-1.71-26.49c0,0,2.81,9.61-2.36,16.08-3.78,4.73-8.32,6.89-16.44,5.13,0,0,8.55-1.61,7.91-6.92s-16.4-11.72-18.35-20.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.3,222.1s-27.19,6.97-35.45,8.18-13.08,6.89-13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.32,199.77s4.44,8.11,3.21,15.45-10,32.89-30.4,46.44c0,0,5.05,7.03,4.95,8.45-.21,2.77-3.04,5.47-4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.92,344.46c-2.67,9.71-4.79,17.02-5.65,19.3,0,0-8.16,18.83-13.62,32.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.18,328.66c-.62,2.32-1.22,4.59-1.82,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.32,305.08c-.41,1.6-.82,3.21-1.24,4.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.93,225.67s6.28,3.27,7.72,6.15,5.5,23.94,5.1,32.19c-.14,2.84-2.81,14.54-6.4,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.18,252.21s-4.33,6.66-4.9,9.27c-1.78,8.17-2.28,31.34-4.79,45.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.13,299.27c24.56-.87,64.17-21,64.17-21l8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.99,242.34s2.12,20.91,3.27,35.93h5.98s-2.3-30.21-3.75-35.93h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.61,216.79s.52,6.68,1.02,12.84l1.36-9.09-.77-11.19-1.61,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.24,275.51s-4.72,4.33-6.54,7.25c-2.57,4.13-2.57,15.52-2.57,15.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.69,95.37l4.04,2.07s10.37-1.45,13.69-1.04,14.72,5.18,17.52,6.95c0,0-1.59-4.46-3.83-6.09-1.28-.93-10.89-5.01-10.89-5.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.47,102.95s7.79,5.28,11.85,5.61,14.37-.52,14.37-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.1,93.3c-.81-.62-11.32-5.23-16.48-7.02-.46-.16-1.4.8-1.4.8,3.93,1.52,18.8,9.51,19.81,9.26l-1.93-3.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72,90.59s1.13,8.51,6.69,14.23,5.76,14.7,4.13,17.56-9.39,12.86-6.12,19.4,10.62,7.55,14.7,7.96c0,0-14.98,3.66-20.64-.4-5.99-4.29-8.35-8.99-6.31-14.92s9.6-12.05,6.53-21.03c-3.06-8.98-11.89-11.97-14.5-21.13s-1.79-9.84-1.79-9.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.23,138.83s1.21-.74,2.42-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.81,134.38s7.72,17.5,11.02,21.24,29.43,27.3,32.99,27.96,2.84.69,4.31.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.29,96.34s-2.34,5-2.08,8.48,2.55,11.04,5.89,15.22c3.34,4.18,6.5,8.48,6.5,8.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.94,165.18s1.91,19.09,1.65,24.82-.64,11.64-.67,18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.31,72.09s-5.79,4.88-4.49,11.38,8.06,14.04,6.24,19.89-30.7,14.14-15.07,41.97c15.63,27.83-.52,34.31-11.44,34.05s-21.05-11.36-21.05-11.36c0,0,3.21,28.87,26.81,23.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.48,191.41s-5.46,14.7-3.54,21.78,5.32,25.33,27.11,26.83c0,0-7.62-10.01-4.35-19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.71,220.45s1.71,13.25,12.18,18.59,27.56,4.27,35.89-3.63c0,0-12.61-1.28-14.96-8.97s-.64-20.72,1.71-26.49c0,0-2.81,9.61,2.36,16.08,3.78,4.73,8.32,6.89,16.44,5.13,0,0-8.55-1.61-7.91-6.92s16.4-11.72,18.35-20.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.96,222.1s27.19,6.97,35.45,8.18,13.08,6.89,13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.94,199.77s-4.44,8.11-3.21,15.45,10,32.89,30.4,46.44c0,0-5.05,7.03-4.95,8.45.21,2.77,3.04,5.47,4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.33,225.67s-6.28,3.27-7.72,6.15-5.5,23.94-5.1,32.19c.4,8.25,24.41,105.37,34.16,125.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.08,252.21s4.33,6.66,4.9,9.27c1.92,8.83,2.36,35.17,5.44,48.69s8.58,32.03,8.58,32.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.13,299.27c-24.56-.87-64.17-21-64.17-21l-8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.27,242.34s-2.12,20.91-3.27,35.93h-5.98s2.3-30.21,3.75-35.93c0,0,5.5,0,5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.64,216.79s-.52,6.68-1.02,12.84l-1.36-9.09.77-11.19,1.61,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.02,275.51s4.72,4.33,6.54,7.25c2.57,4.13,2.57,15.52,2.57,15.52"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.32,23.91s-26.61,21.18-31.72,28.55-6.92,17.52-6.92,17.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.29,19.75s11.72-2.84,21.74,2.84,15.5,14.56,17.39,25.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.94,62.98s14.56-11.09,25.53-9.2,16.26,6.43,16.26,6.43c0,0-2.65-16.26-16.64-16.26s-19.74,8.89-22.06,12.86-14.45,33.78-29.74,33.78-34.79,2.52-42.54-27.73c0,0,10.02,9.45,20.42,7.37,10.4-2.08,21.74-15.31,21.74-15.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.2,50.22s9.77-4.31,17.75,3.53,12.69,29.42,9.83,38.51-11.43,12.15-14.5,21.13c-3.06,8.98,4.49,15.11,6.53,21.03,2.04,5.92-.33,10.63-6.31,14.92-5.66,4.06-20.64.4-20.64.4,4.08-.41,11.43-1.43,14.7-7.96s-4.49-16.54-6.12-19.4-.24-10.89,4.13-17.56c5.55-8.47,6.8-22.58-.72-32.73-6.29-8.49-12.26-14.26-17.11-11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.91,72.09c-1.97-9.11,1.72-21.67-2.96-29.8s-18.96-11.58-23.15-14.04-11.58-20.44-27.83-24.38S110.1-.07,86.7,11.5c-23.4,11.58-35.49,50.76-36.62,54.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.43,21.53c4.43,3.76,6.18,18.29,6.18,18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108,151.97c4.02,0,10.55,2.01,14.77,2.71s16.99.3,18.79,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.02,345.54s15.69-7.77,21.91-7.99,74.81-8.44,90.58-15.1c0,0,2.94.6,8.41-2.38s31.29-25.36,31.29-25.36c0,0,14.03-.94,23.7-4.46,0,0,10.43,4.14,10.93,5.63s-.33,6.13,0,7.62-5.14,4.57-6.51,1.57c-.86-1.88-.84-4.44-4.32-3.78s-11.74,4.03-11.74,4.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.33,313.12c3.64,2.32,19.88,6.63,20.37,8.61,0,0,1.66-4.97,1.66-6.79s-2.15-3.64-8.28-5.47-16.56-6.63-16.56-6.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.7,321.73c0,6.46-2.32,7.78-4.67,6.96s-12.76-.66-12.76-.66c0,0,3.19,4.8,6.66,6.96s2.94,4.97,2.05,7.29-10-1.16-11.49-1.16-26.5,8.94-40.91,5.63c0,0-91.97,33.9-112.62,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.21,353.38s-6.98-5.93-21.86-4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.33,333.67s-13.95-7.18-17.4-7.88-23.49,3.59-28.48,3.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmineidle);
export default __webpack_public_path__ + "static/media/jasmine idle.4e9b4c6c522f8fa0c185fdb1debbe1ba.svg";
export { ForwardRef as ReactComponent };